import { Flex } from "@radix-ui/themes";
import { Outlet } from "react-router-dom";

export default function BaseLayout() {
  return (
    // <Flex direction="column" height="100%" style={{ overflow: "auto" }}>
      // <Flex direction="row" height="100%" style={{ overflow: "auto" }}>
        <Outlet />
      // </Flex>
    // </Flex>
  );
}
